// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AddTeam from '../addTeam';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import AddMember from '../addTournamentTeamMember';
import Dialog from 'material-ui/Dialog';
import Chip from 'material-ui/Chip';

class DeleteCompetitionTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id:props.match.params.id,
      confirmDelete:false,
    };
  }


  componentDidMount() {
    this.getaddTeamInputs();
    this.getTeamList();
    this.getTeamDetailInput();
    console.log(this.state);
  }

  toDeleteTeam(){
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/delete_TournamentTeam/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'team_id': this.state.id

                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => { alert(data.message)
              this.props.history.goBack();
              })
           .catch(error => {
             console.log(error);
             alert(error.message);
           });

  }
  handleBack(){
    this.props.history.goBack();
  }
  renderChip(data) {
    
    return (
      <Chip
        key={data.id}
        onRequestDelete={() => this.handleRequestDelete(data)}
        style={styles.chip}
      >
        {data.name}
      </Chip>
    );
  }

  render() {
    console.log('Teams')
    console.log(this.state)
    const deleteAction = [
        <input type="button" className="button1" value="Delete" style={{backgroundColor:'red',marginRight:'20px'}} onClick={() => {this.toDeleteTeam()}} />,
        <input type="button" className="button1" value="Cancel" onClick={() => {this.handleBack()}} />
      ];
    return(


      <div>
            
              <Dialog
                    actions={deleteAction}
                    modal={false}
                    open={true}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                    style={{textAlign:'center'}}
                    scroll={scroll}
                    dividers={scroll === 'paper'}
                    >
                    <h3> Do you want to delete this Team </h3>
              </Dialog>
      </div>
    );
  }
}

export default DeleteCompetitionTeam;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/deleteCompetitionTeam/index.js